export enum Source {
  MovingWaldo = 'MovingWaldo',
  Google = 'Google',
}
